import { ReactNode } from "react";
import { View } from "./View";

export interface ICheckedProps {
  onToggle: (value: boolean) => void;
  isLoading: boolean;
  checked?: boolean;
}

export const Slider = (props: ICheckedProps) => {
  return <View {...props} />;
};
